import { cn } from '@/utils/utils';
import './style.scss';

// Carousel icon
const CarouselArrowLeft = ({
    className = '',
    fill = 'var(--clr-white)',
    color = 'var(--clr-primary-web)',
    width = 30,
    height = 30
}) => {
    return (
        <div className={cn('carousel-button', className)}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width={width}
                height={height}
                viewBox='0 0 30 30'
                fill='none'
                className='carousel-arrow carousel-arrow-left'
            >
                <path
                    d='M14.9999 30C6.71566 30 -1.90735e-06 23.2843 -1.90735e-06 15.0001C-1.90735e-06 6.71574 6.71566 0 14.9999 0C23.2843 0 30 6.71574 30 15.0001C30 23.2843 23.2843 30 14.9999 30Z'
                    fill={fill}
                    className='circle'
                />
                <path
                    d='M16.5424 11.215L12.0564 15.7009L16.5424 20.1869'
                    fill={fill}
                    className='arrow-fill'
                />
                <path
                    d='M16.5424 11.215L12.0564 15.7009L16.5424 20.1869'
                    stroke={color}
                    strokeWidth='2.24299'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='arrow-stroke'
                />
            </svg>
        </div>
    );
};

const CarouselArrowRight = ({
    className = '',
    fill = 'var(--clr-white)',
    color = 'var(--clr-primary-web)',
    width = 30,
    height = 30
}) => {
    return (
        <div className={cn('carousel-button', className)}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width={width}
                height={height}
                viewBox='0 0 30 30'
                fill='none'
                className='carousel-arrow carousel-arrow-right'
            >
                <path
                    d='M14.9999 30C6.71566 30 -1.90735e-06 23.2843 -1.90735e-06 15.0001C-1.90735e-06 6.71574 6.71566 0 14.9999 0C23.2843 0 30 6.71574 30 15.0001C30 23.2843 23.2843 30 14.9999 30Z'
                    fill={fill}
                    className='circle'
                />
                <path
                    d='M13.4576 11.215L17.9436 15.7009L13.4576 20.1869'
                    fill={fill}
                    className='arrow-fill'
                />
                <path
                    d='M13.4576 11.215L17.9436 15.7009L13.4576 20.1869'
                    stroke={color}
                    strokeWidth='2.24299'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='arrow-stroke'
                />
            </svg>
        </div>
    );
};

export {
    CarouselArrowLeft,
    CarouselArrowRight
};
